var _linearGradient, _path, _linearGradient2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Exchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W9HD9PERLn5XX1qKvSW0Pa",
    x1: 18,
    x2: 49.592,
    y1: 184,
    y2: 184,
    gradientTransform: "rotate(180 27 100)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W9HD9PERLn5XX1qKvSW0Pa)",
    d: "M4.917,17.35L11,24h25V10c0-1.105-0.895-2-2-2H12.322c-0.842,0-1.645,0.354-2.214,0.975 L4.917,14.65C4.238,15.393,4.238,16.607,4.917,17.35z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W9HD9PERLn5XX1qKvSW0Pb",
    x1: 24.592,
    x2: 56.184,
    y1: 64,
    y2: 64,
    gradientTransform: "translate(-13.592 -32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W9HD9PERLn5XX1qKvSW0Pb)",
    d: "M42.083,30.65L36,24H11v14c0,1.105,0.895,2,2,2h21.678c0.842,0,1.645-0.354,2.214-0.975 l5.191-5.675C42.762,32.607,42.762,31.393,42.083,30.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.773,27.687c0-5.654-8.348-4.55-8.348-7.891c0-1.744,1.96-1.836,2.574-1.836 c1.474,0,2.896,0.395,3.98,0.904c0.342,0.16,0.734-0.077,0.734-0.454v-1.645c0-0.552-0.208-0.879-0.539-1.008 c-0.744-0.289-1.811-0.5-3.39-0.552v-1.811c0-0.217-0.176-0.393-0.393-0.393h-0.786c-0.217,0-0.393,0.176-0.393,0.393v1.84 c-2.448,0.239-4.988,1.621-4.988,4.837c0,5.861,8.347,4.699,8.347,7.786c0,0.97-0.62,1.807-2.574,1.807 c-1.964,0-3.769-0.686-4.768-1.197c-0.336-0.172-0.732,0.077-0.732,0.455v1.873c0,0.359,0.216,0.679,0.547,0.819 c1.184,0.503,2.771,0.883,4.167,0.995v2.001c0,0.217,0.176,0.393,0.393,0.393h0.786c0.217,0,0.393-0.176,0.393-0.393V32.61 C28.449,32.305,29.773,29.852,29.773,27.687z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Exchange);
export default __webpack_public_path__ + "static/media/icons8-exchange.e5982022988ec586782d9738780550a4.svg";
export { ForwardRef as ReactComponent };